angular.module('impactx.search').component('ixProductItem', {
        bindings: {
            product: '<',
            vCatId: '<'
        },
        require: {
            listCtrl: '^^ixProductList'
        },
        controller: 'ProductItemCtrl',
        controllerAs: 'itemCtrl',
        templateUrl: 'modules/search/templates/product-item.html'
    }
);